Vue.component('v-product', require('./view/product/index.vue').default);

setTimeout(window.startup, 10);
